import React, { Component } from 'react';
import {
  Button,
} from 'react-bootstrap';
import {
  Section,
  Title,
  Gallery,
} from './Section';
import PriceCard from '../../components/Shared/PriceCard';
import appHistory from '../../history';

import './Landing.css';

class SimplePricing extends Component {
  render() {
    return (
      <Section>
        <Title title="SIMPLE" subtitle="PRICING." />
        <Gallery>
          <PriceCard title="Base Plan" price="5" pcStyle="theme"
            features={[
              "Real-time control",
              "Unlimited passcodes",
              "Detail access logs",
              "Call forwarding",
              "No contract",
              "30-day free",
            ]}
            footer={this.renderGetStartedButton()}
          />
          <PriceCard title="Add-ons" price="x"
            pcStyle="primary" schedule="monthly / add-on" disabled={true}
            features={[
              "Enhanced passcodes",
              "Lockdown protection",
              "Personal customizations",
              "more",
            ]}
            footer={this.renderComingSoonButton()}
          />
        </Gallery>
      </Section>
    );
  }

  renderGetStartedButton = () => {
    return (
      <Button className="btn-theme" type="button" block
        onClick={() => {
          appHistory.push("/auth/signup");
        }}>
        Get Started!
      </Button>
    )
  }

  renderComingSoonButton = () => {
    return (
      <Button bsStyle="primary" type="button" block disabled>
        Coming soon!
      </Button>
    )
  }
}

export default SimplePricing


// WEBPACK FOOTER //
// ./src/entries/Static/SimplePricing.js